import { createFileRoute, redirect } from "@tanstack/react-router";
import { AccreditationDashboard, accreditationDashboardSearch } from "../../components/dashboard/accreditation-dashboard";
import { homeDashboardFor } from "../../lib/dashboard/sectors";

/**
 * "/". The admins and a NOC have their own dashboards (user, 2026-10-31):
 * "/" sends them there (`homeDashboardFor` — a NOC to the sector it has
 * reached, the admins to the overall Dashboard). Every other role keeps the
 * accreditation dashboard here.
 */
export const Route = createFileRoute("/_app/")({
	validateSearch: accreditationDashboardSearch,
	beforeLoad: ({ context, search }) => {
		const home = homeDashboardFor(context.session);
		if (home === "/dashboard/accreditation") throw redirect({ to: home, search, replace: true });
		if (home) throw redirect({ to: home, replace: true });
	},
	// Her dashboard runs full width (.pg--dash); see ContentWidth in router.tsx.
	staticData: { contentWidth: "full" },
	component: Dashboard,
});

function Dashboard() {
	const { session } = Route.useRouteContext();
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	return <AccreditationDashboard session={session} search={search} onChange={(patch) => navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })} />;
}
